// extracted by mini-css-extract-plugin
export default {"processItemChange":"processItemChange-mglG_","icon":"icon-KAuo8","text":"text-S8Dr8","label":"label-l_GHo"};